import { faClock, faFire, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAllRecipes } from '../components/api';

function MealsOfTheDay() {
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllRecipes()
      .then((recipes) => {
        // Get 3 random recipes for meals of the day
        const shuffled = [...(recipes || [])].sort(() => 0.5 - Math.random());
        setMeals(shuffled.slice(0, 3));
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching meals:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-pulse text-2xl text-gray-400">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Header Section */}
      <div className="border-b-4 border-black">
        <div className="max-w-6xl mx-auto px-6 py-16 text-center">
          <h1 className="text-6xl font-black text-black mb-4">
            MEALS OF THE DAY
          </h1>
          <p className="text-xl text-gray-700 font-medium max-w-2xl mx-auto">
            Three handpicked recipes. Fresh ideas. Real flavor.
          </p>
        </div>
      </div>

      {/* Meals Grid */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          {meals.map((meal, index) => (
            <div
              key={meal.id}
              onClick={() => navigate(`/recipe/${meal.id}`)}
              className="group cursor-pointer"
            >
              {/* Meal Number */}
              <div className="mb-4">
                <span className="text-8xl font-black text-gray-200 group-hover:text-gray-900 transition-colors duration-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>

              {/* Image */}
              <div className="relative h-80 mb-6 overflow-hidden bg-gray-100">
                {meal.imageURL ? (
                  <img
                    src={meal.imageURL}
                    alt={meal.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div className="flex items-center justify-center h-full">
                    <FontAwesomeIcon icon={faUtensils} className="text-gray-300 text-6xl" />
                  </div>
                )}
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
              </div>

              {/* Title */}
              <h2 className="text-2xl font-bold text-black mb-4 group-hover:underline">
                {meal.title}
              </h2>

              {/* Meta Info */}
              <div className="flex gap-6 text-sm text-gray-600 font-medium">
                {meal.cookingMinutes && (
                  <div className="flex items-center gap-2">
                    <FontAwesomeIcon icon={faClock} />
                    <span>{meal.cookingMinutes} MIN</span>
                  </div>
                )}
                {meal.calories && (
                  <div className="flex items-center gap-2">
                    <FontAwesomeIcon icon={faFire} />
                    <span>{meal.calories} KCAL</span>
                  </div>
                )}
              </div>

              {/* Difficulty Badge */}
              {meal.difficulty && (
                <div className="mt-4 inline-block">
                  <span className="px-4 py-1 bg-black text-white text-xs font-bold uppercase tracking-wider">
                    {meal.difficulty}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Refresh Button */}
        <div className="text-center mt-16">
          <button
            onClick={() => window.location.reload()}
            className="px-8 py-4 bg-black text-white font-bold text-lg uppercase tracking-wider hover:bg-gray-800 transition-colors"
          >
            Get New Meals
          </button>
        </div>
      </div>
    </div>
  );
}

export default MealsOfTheDay;
